<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Group Sharing</b>
        <b-button
          v-show="hasGroups"
          v-if="isOrgAdmin && hasMoreGroupsToShareWith"
          disabled
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
        >
          <span class="button-text">Share with</span>
        </b-button>
      </b-card-header>

      <!-- List groups -->
      <div v-if="shareCseitRecords.length > 0">
        <b-list-group v-for="sp in shareCseitRecords" :key="sp.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent="toggleUpdateShareCseitModal(sp.id)">
              {{ _.get(sp, 'sgroup.groupName', 'Unknown') }} <img :src="'/static/img/' + (sp.cseitShareStatus ? 'shareYes.png' : 'shareNo.png')" height="21" width="21">
            </a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="shareCseitRecords.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>{{ !hasGroups ? 'Your organization does not belong to any groups' : 'This record is not currently shared' }}</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- View/Update Existing -->
    <UpdateShareCseitModal
      :cseitId="cseitId"
      :cseitOrganizationOwner="cseitOrganizationOwner"
      :shareRecord="shareRecord"
      :groupId="selectedGroup"
    ></UpdateShareCseitModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateShareCseitModal from '@/components/Share/UpdateShareCseitModal'

export default {
  name: 'share-cseit-list',
  props: {
    cseitId: Number,
    cseitOrganizationOwner: Number,
    personId: Number
  },
  components: {
    UpdateShareCseitModal
  },
  data: function () {
    return {
      showUpdateCseitModal: false,
      selectedGroup: {},
      shareRecordId: 0
    }
  },
  computed: {
    ...mapGetters({
      shareCseitRecords: 'shareCseitRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userTransferAllowed: 'userTransferAllowed',
      userCurrentContext: 'userCurrentContext' // Passing user context to determine if they have isOrgAdmin
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    },
    hasMoreGroupsToShareWith: function () {
      let condition = false
      let countGroups = this.getGroupsByOrg.length || 0
      let countShareRecords = this.shareCseitRecords.length || 0
      // console.log('hasMoreGroups: countGroups=' + countGroups + ' countShareRecords=' + countShareRecords)
      if (countGroups > countShareRecords) {
        condition = true
      }
      return condition
    },
    isOrgAdmin: function () {
      return this.userTransferAllowed(this.cseitOrganizationOwner)
    },
    shareRecord: function () {
      return this.shareCseitRecords.find((r) => r.id === this.shareRecordId)
    }
  },
  watch: {
    cseitId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getShareCseitRecords', {
          sassessment: newValue,
          populate: 'sgroup'
        })
      }
    }
  },
  methods: {
    toggleUpdateShareCseitModal: function (shareRecordId) {
      this.shareRecordId = shareRecordId
      // this.showUpdateCseitModal = !this.showUpdateCseitModal
      this.$bvModal.show('update-share-cseit')
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'shareCseitResponse' })
      this.$store.commit('RESET_SHARE_CSEIT_RECORDS')
    }
  },
  beforeDestroy () {
    this.resetAll()
  },
  created () {
    if (this.cseitId && _.isInteger(this.cseitId)) {
      this.$store.dispatch('getShareCseitRecords', {
        scseit: this.cseitId,
        populate: 'sgroup,scseit'
      })
      this.$store.dispatch('getGroupsByOrg', { id: this.cseitOrganizationOwner })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Cseit/ShareCseitList.vue